/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { string, bool as boolType, func } from 'prop-types';
import { useDataModel, extend } from '@thd-nucleus/data-sources';
import { useStore, ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import { dynamicRecsDataModel, pipRecsModel } from '../dataModel';
import { VerticalRecs } from './VerticalRecs';
import '../../styles/thd-recs-containers.scss';

const VerticalRecsWrapper = (props) => {

  const {
    itemId,
    maxResults,
    recsIframeFlag,
    updateRecsATCButton
  } = props;
  const { channel } = useContext(ExperienceContext);
  const { storeId } = useStore();
  const isMobile = channel === 'mobile';
  const isSecondRecsEnable = useConfigService('fs:isSecondRecsEnable');
  const { data: productData } = useDataModel('clientOnlyProduct', {
    variables: {
      itemId,
      storeId
    },
    skip: recsIframeFlag === true || !itemId,
    ssr: false,
  });
  let apiName = '';
  const recsFlag = productData?.product?.info?.recommendationFlags;
  if (recsFlag?.batItems) {
    apiName = ['atc', 'battery_collection'];
  } else if (recsFlag?.pipCollections) {
    apiName = ['atc', 'pipcollection'];
  } else if (recsFlag?.collections) {
    apiName = ['atc', 'brand_based_collection'];
  } else {
    apiName = ['atc'];
  }

  if (!isSecondRecsEnable) {
    apiName = ['atc'];
  }

  return (
    <>
      { !isMobile && <hr className="sui-mx-4 sui-my-1" /> }
      {(apiName && apiName.length > 0 && apiName?.map((schemaName, key) => {
        return (
          <VerticalRecs
            itemId={itemId}
            key={key}
            apiName={schemaName}
            recsIframeFlag={recsIframeFlag}
            maxResults={maxResults}
            updateRecsATCButton={updateRecsATCButton}
          />
        );
      })
      )}
    </>
  );
};

VerticalRecsWrapper.displayName = 'VerticalRecsWrapper';

const propTypes = {
  itemId: string.isRequired,
  maxResults: string,
  recsIframeFlag: boolType,
  updateRecsATCButton: func
};

const defaultProps = {
  maxResults: '',
  recsIframeFlag: false,
  updateRecsATCButton: () => { }
};
VerticalRecsWrapper.dataModel = extend(
  pipRecsModel,
  dynamicRecsDataModel,
  podFulFillmentUtils
);

VerticalRecsWrapper.propTypes = propTypes;
VerticalRecsWrapper.defaultProps = defaultProps;

export { VerticalRecsWrapper };